import { render, staticRenderFns } from "./IssueListItemRelationList.vue?vue&type=template&id=45dd0e9a&scoped=true"
import script from "./IssueListItemRelationList.vue?vue&type=script&lang=js"
export * from "./IssueListItemRelationList.vue?vue&type=script&lang=js"
import style0 from "./IssueListItemRelationList.vue?vue&type=style&index=0&id=45dd0e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd0e9a",
  null
  
)

export default component.exports